/**
 * Membership represents the assignment of a user to a group.
 * Path: /Users/{uid}/memberships/{membershipId}
 */
var MembershipRole;
(function (MembershipRole) {
    MembershipRole["MEMBER"] = "member";
    MembershipRole["MANAGER"] = "manager";
    MembershipRole["OWNER"] = "owner";
    MembershipRole["SUPER_ADMIN"] = "super_admin";
})(MembershipRole || (MembershipRole = {}));

export { MembershipRole };
//# sourceMappingURL=Membership.js.map
